import type { IxcMutualfundsV1DividendAccrualKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH = getResolvedPath('/clearing/operations/mutualfunds/dividend-accrual');

export const getDividendAccrualPath: EntityPathBuilder<IxcMutualfundsV1DividendAccrualKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.accountId || !context?.keys?.assetId || !context?.keys?.source || !context?.keys?.firstDayOfMonth) {
        return undefined;
      }

      return getResolvedPath(`${MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH}/$accountId/$assetId/$source/$firstDayOfMonth`, context.keys);
    }
  }
};
